import { SettingsAlertComponent } from './settings-alert.component';

export default angular
  .module('sfMobile.components.settings-alert', [
    'sfMobile.services.app-settings',
    'sfMobile.components.button-header-close',
  ])
  .component('sfSettingsAlert', SettingsAlertComponent).name;
